import {observer} from 'mobx-react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import TaxFormTemplateEditor from './TaxFormTemplateEditor';

const TaxFormTemplatesPage = observer(() => {
  return (
    <Router basename='/tax_form_templates'>
      <Switch>
        <Route path='/:id/edit' component={TaxFormTemplateEditor}/>
      </Switch>
    </Router>
  );
});

export default TaxFormTemplatesPage;
